import React, { Component } from 'react';

export class PrivacyPolicy extends Component {
    static displayName = PrivacyPolicy.name;

    render() {
        return (
          <div>
          <section className="container-inner content-section mb-20">
            <article className="flex-column">
              <h1>Privacy Policy and Notice of Collection</h1>
              <p>This Privacy Policy describes how M.D.C. Holdings, Inc. and its Richmond American Homes subsidiaries (collectively, “Company,” “we,” “us,” or “our”) collect, use, protect, and disclose personal information. This Privacy Policy also tells you about your rights and choices with respect to your personal information, and how you can reach us to get answers to your questions.&nbsp;</p>
              <p>For Do Not Sell My Information and Other Requests:</p>
              <button className="btn btn--secondary" onclick="window.location.href = '/ccpa'">Privacy opt-out request </button></article>
          </section>
          <section className="container-inner content-section">
            <article className="flex-column">
            </article></section></div>
        );
    }
}
export default PrivacyPolicy
